document.addEventListener('DOMContentLoaded',()=>{

    const section = document.querySelector('.vs-monaco-editorial');
    const track = document.getElementById('vsMonacoTrack');
    const slides = document.querySelectorAll('.vs-monaco-slide');
    const dotsWrap = document.getElementById('vsMonacoDots');
    const prevBtn = section ? section.querySelector('.vs-monaco-prev') : null;
    const nextBtn = section ? section.querySelector('.vs-monaco-next') : null;

    if(!track || slides.length === 0) return;

    let current = 0;

    // Initialize first slide
    slides[0].classList.add('active');

    // Setup slider dots
    slides.forEach((slide, index) => {

        if (dotsWrap) {
            const dot = document.createElement('div');
            dot.className = 'vs-monaco-dot';
            if (index === 0) dot.classList.add('active');

            dot.addEventListener('click', () => {
                current = index;
                updateSlider();
            });

            dotsWrap.appendChild(dot);
        }

        // Setup size selection on chips inside each slide
        const chips = slide.querySelectorAll('.vs-monaco-size-chip');
        const formInput = slide.querySelector('.vs-monaco-form input[name="id"]');

        chips.forEach(chip => {
            chip.addEventListener('click', (e) => {
                e.preventDefault();
                chips.forEach(c => c.classList.remove('active'));
                chip.classList.add('active');

                // If variant ID is stored in data attribute, update hidden input
                const variantId = chip.getAttribute('data-variant-id');
                if (variantId && formInput) {
                    formInput.value = variantId;
                }
            });
        });

        // Mouse movement view badge effect on editorial image
        const right = slide.querySelector('.vs-monaco-right');
        const view = slide.querySelector('.vs-monaco-view');

        if (right && view) {
            right.addEventListener('mousemove', (e) => {
                const rect = right.getBoundingClientRect();
                view.style.left = (e.clientX - rect.left) + 'px';
                view.style.top = (e.clientY - rect.top) + 'px';
            });
        }
    });

    // Bind outer navigation arrows
    if (nextBtn) {
        nextBtn.addEventListener('click', (e) => {
            e.preventDefault();
            current = (current + 1) % slides.length;
            updateSlider();
        });
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', (e) => {
            e.preventDefault();
            current = (current - 1 + slides.length) % slides.length;
            updateSlider();
        });
    }

    function updateSlider() {
        track.style.transform = `translateX(-${current * 100}%)`;

        slides.forEach((s, idx) => {
            if (idx === current) {
                s.classList.add('active');
            } else {
                s.classList.remove('active');
            }
        });

        const dots = document.querySelectorAll('.vs-monaco-dot');
        dots.forEach((dot, idx) => {
            if (idx === current) {
                dot.classList.add('active');
            } else {
                dot.classList.remove('active');
            }
        });
    }

});